<template>
  <el-switch
    :value="value === 'active'"
    active-text="展示"
    inactive-text="隐藏"
    @change="confirmChange"
  />
</template>

<script>
export default {
  name: "PublishSwitch",
  props: {
    value: { type: String, default: "inactive" }
  },
  methods: {
    confirmChange(checked) {
      const status = checked ? "active" : "inactive";
      this.$confirm(`确定${checked ? "展示" : "隐藏"}该内容吗？`, "状态确认", { type: "warning" })
        .then(() => this.$emit("change", status))
        .catch(() => {});
    }
  }
};
</script>
